import type { MailboxInfo } from 'owa-client-types';
import { type Capability } from 'owa-capabilities';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getCurrentModule } from 'owa-app-module-store';
import { Module } from 'owa-workloads-module';

export const bizchatDrawerCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        const currentModule = getCurrentModule();
        return (
            isFeatureEnabled('mon-copilot-bizchat-drawer') &&
            (currentModule !== Module.Addison || isFeatureEnabled('addison-copilot-bizchat-drawer'))
        );
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        const currentModule = getCurrentModule();
        return (
            currentModule === Module.Mail ||
            currentModule === Module.Calendar ||
            currentModule === Module.Addison
        );
    },
};
